import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Card, CardContent, CardHeader, CardTitle } from '../../components/ui/card';
import { Badge } from '../../components/ui/badge';
import { Button } from '../../components/ui/button';
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from '../../components/ui/table';
import { XCircle } from '@phosphor-icons/react';
import { formatCurrency, formatDate } from '../../lib/utils';

const STATUS_BADGE_CLASS = {
  Paid: 'bg-emerald-50 text-emerald-700',
  Pending: 'bg-amber-50 text-amber-700',
  Submitted: 'bg-blue-50 text-blue-700',
  Rejected: 'bg-red-50 text-red-700',
};

const InlineFilteredResults = ({ activeFilter, claims, onClear }) => {
  const navigate = useNavigate();
  const title =
    activeFilter.type === 'all' ? 'All Claims' : `${activeFilter.value} Claims`;

  return (
    <Card
      className="border-indigo-200 animate-fade-in"
      data-testid="inline-filter-results"
    >
      <CardHeader className="pb-3">
        <div className="flex items-center justify-between">
          <CardTitle className="text-base" style={{ fontFamily: 'Manrope' }}>
            {title} ({claims.length})
          </CardTitle>
          <Button
            variant="ghost"
            size="sm"
            onClick={onClear}
            data-testid="close-inline-filter"
          >
            <XCircle size={16} className="mr-1" /> Clear
          </Button>
        </div>
      </CardHeader>
      <CardContent className="p-0">
        {claims.length === 0 ? (
          <p className="text-sm text-slate-500 text-center py-8">No claims found</p>
        ) : (
          <Table>
            <TableHeader>
              <TableRow>
                <TableHead>Patient</TableHead>
                <TableHead>Service Date</TableHead>
                <TableHead>Service Code</TableHead>
                <TableHead>Status</TableHead>
                <TableHead className="text-right">Amount</TableHead>
              </TableRow>
            </TableHeader>
            <TableBody>
              {claims.slice(0, 20).map((claim) => (
                <TableRow
                  key={claim.id}
                  className="cursor-pointer hover:bg-slate-50"
                  onClick={() => navigate('/claims')}
                >
                  <TableCell className="font-medium">{claim.patient_name}</TableCell>
                  <TableCell>{formatDate(claim.service_date)}</TableCell>
                  <TableCell className="font-mono text-xs">{claim.service_code}</TableCell>
                  <TableCell>
                    <Badge
                      variant="outline"
                      className={
                        STATUS_BADGE_CLASS[claim.status] || 'bg-slate-50 text-slate-700'
                      }
                    >
                      {claim.status}
                    </Badge>
                  </TableCell>
                  <TableCell className="text-right">
                    {formatCurrency(claim.total_charge || 0)}
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        )}
      </CardContent>
    </Card>
  );
};

export default InlineFilteredResults;
